import styled, { keyframes } from 'styled-components';
import { TABLET_WIDTH } from 'constants/breakPoints';

export const CustomCardWrapper = styled.div`
  border-radius: 4px;
  width: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;  
  height: 100%;
  padding-left: 90px;
  padding-right: 90px;

  @media (max-width: ${TABLET_WIDTH}px) {
    max-height: 78vh;
    overflow-y: none;
    height: auto;
    padding-left: 0px;
    padding-right: 0px;
  }
`;

export const CardBody = styled.div`
  order: 1;
  flex-grow: 2;
`;

const highlight = backgroundColorText => keyframes`
  from {
    background-image: none;
    background-repeat: no-repeat;
    background-position: left center;
    background-size: 0% 100%;
  }
  to {
    color: ${backgroundColorText};
    background-image: linear-gradient(#fff, #fff);
    background-repeat: no-repeat;
    background-position: left center;
    background-size: 100% 100%;
  }  
`;

export const Title = styled.div`
  color: ${props => props.color || '#fff'};
  line-height: ${props => `min(${props.maxFontSize + 6}px, 22px + (24 - 22) * ((100vw - 320px) / (412 - 320)))`};
  font-size: ${props => `min(${props.maxFontSize}px, 16px + (18 - 16) * ((100vw - 320px) / (412 - 320)))`};
  font-family: 'helvetica neue light';
  padding-bottom: 5px;
  text-align: center;
  max-width: ${props => props.maxWidth};
  display: inline-block;
  vertical-align: middle;
  margin: 15px;

  left: 0px;
  right: 10px;
  position: relative;
  font-family: 'helvetica neue';

  strong {
    font-family: 'helvetica neue';
    color: #173630;
    font-weight: 600;
    border-radius: 7px;
    padding-left: 8px;
    padding-right: 8px;
    white-space: nowrap;
    animation: 1s ease-out 0.5s 1 forwards ${props => highlight(props.backgroundColorText)};
  }
`;



// WEBPACK FOOTER //
// ./src/routes/ElementForm/components/styles.js